/**
 * Testimonial Random Character Animation
 * Randomly animates individual characters with color transitions
 */

export function initTestimonialAnimation() {
  const highlightedParagraphs = document.querySelectorAll<HTMLElement>('.testimonial-card__quote-highlight')

  highlightedParagraphs.forEach(paragraph => {
    // Wrap each character in a span for individual animation
    wrapCharacters(paragraph)

    // Start random character animation
    startRandomAnimation(paragraph)
  })
}

function wrapCharacters(element: HTMLElement) {
  const textNodes: Text[] = []

  // Collect all text nodes
  function collectTextNodes(node: Node) {
    if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
      textNodes.push(node as Text)
    } else {
      node.childNodes.forEach(collectTextNodes)
    }
  }

  collectTextNodes(element)

  // Wrap each character in a span
  textNodes.forEach(textNode => {
    const text = textNode.textContent || ''
    const fragment = document.createDocumentFragment()

    for (const char of text) {
      const span = document.createElement('span')
      span.setAttribute('data-color-wave-char', 'true')
      span.style.transition = 'color 200ms ease'
      span.textContent = char
      fragment.appendChild(span)
    }

    textNode.parentNode?.replaceChild(fragment, textNode)
  })
}

function startRandomAnimation(quote: HTMLElement) {
  const chars = Array.from(quote.querySelectorAll<HTMLSpanElement>('[data-color-wave-char]'))

  // Color palette - darker versions of hero reel animation colors for better text visibility
  const colors = [
    '#325EFC', // Blue
    '#1BA39C', // Darker Teal
    '#C94277', // Darker Magenta
    '#8B5CF6', // Purple (replaces yellow for better text visibility)
  ]

  function animateRandomChar() {
    // Pick a random character
    const randomIndex = Math.floor(Math.random() * chars.length)
    const char = chars[randomIndex]

    // Pick a random color
    const colorIndex = Math.floor(Math.random() * colors.length)
    char.style.color = colors[colorIndex]

    // Reset to original color after a short time
    setTimeout(() => {
      char.style.color = ''
    }, 800)
  }

  // Continuously animate random characters
  setInterval(() => {
    // Animate 2-5 random characters at once
    const numChars = Math.floor(Math.random() * 4) + 2
    for (let i = 0; i < numChars; i++) {
      animateRandomChar()
    }
  }, 300) // Every 300ms
}
